/**
 * Permissions the API recognises.
 *
 * The frontend's copy of the backend catalogue, same deal as `ApiErrorCode`: the
 * interface decides what to show from the code, and a code that is not in here
 * is simply a permission this build knows nothing about.
 *
 * A code is `module:action`. The part before the colon is what the interface
 * reads as a module, which is why the group editor can group the catalogue it
 * receives without being told how.
 */
export const Permission = {
  USERS_READ: 'users:read',
  USERS_CREATE: 'users:create',
  USERS_UPDATE: 'users:update',
  USERS_DELETE: 'users:delete',
  USERS_ASSIGN: 'users:assign',
  GROUPS_READ: 'groups:read',
  GROUPS_CREATE: 'groups:create',
  GROUPS_UPDATE: 'groups:update',
  GROUPS_DELETE: 'groups:delete',
  VIRTUAL_PROFILER_READ: 'virtual-profiler:read',
  VIRTUAL_PROFILER_OPERATE: 'virtual-profiler:operate',
  VIRTUAL_PROFILER_WRITE: 'virtual-profiler:write',
  VIRTUAL_PROFILER_CONFIGURE: 'virtual-profiler:configure',
  VIRTUAL_PROFILER_DELETE: 'virtual-profiler:delete',
} as const;

/**
 * The codes this build acts on: route metadata, gated buttons, `can()`.
 *
 * Whatever only *renders* the catalogue —the group editor, the 403 screen— works
 * on plain strings instead, because `GET /permissions` can serve codes that were
 * added after this bundle was built.
 */
export type Permission = (typeof Permission)[keyof typeof Permission];
